<ng-container *ngIf="pieChartData$ | async as pieChartData">
  <ng-container *ngIf="pieChartData && pieChartData.datasets && pieChartData.datasets.length > 0">
    <canvas baseChart class="chart !flex items-center -mt-3 -mr-1" [width]="icon_size&&icon_size*2" [height]="icon_size&&icon_size*2" [data]="pieChartData" [type]="'pie'" [options]="pieChartOptions">
      </canvas>
  </ng-container>
</ng-container>
